import { render, staticRenderFns } from "./SettingWithdraw.vue?vue&type=template&id=7b1df833"
import script from "./SettingWithdraw.vue?vue&type=script&lang=js"
export * from "./SettingWithdraw.vue?vue&type=script&lang=js"
import style0 from "./SettingWithdraw.vue?vue&type=style&index=0&id=7b1df833&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports